import { Box } from "@chakra-ui/react";
import { Spacing } from "goi_common";
import { baseColors, BaseButton, BaseStack } from "goi_common/src/design-system";
import { DIFF_ITEMS } from "./sangjoLandingData";
import { Accent, Eyebrow, GraphicIcon, LandingSection, SectionTitle } from "./SangjoLandingUI";

export default function SangjoLandingDiff({
  onGoForm,
  onRequest,
}: {
  /** "내 상황에 맞는 예상 비용 확인하기" → 하단 제출 폼 */
  onGoForm: () => void;
  /** "장례 전체 예상 비용 알아보기" → /match/request */
  onRequest: () => void;
}) {
  return (
    <LandingSection>
      <Eyebrow>고이는 이렇게 달라요</Eyebrow>
      <Spacing gap={8} />
      <SectionTitle>
        비용은 투명하게,
        <br />
        <Accent>장례는 안심하고</Accent> 맡기세요
      </SectionTitle>
      <Spacing gap={12} />
      <Box className="body_2_reading_r" color={baseColors.label_alternative_1}>
        필요한 서비스와 예상 비용을 먼저 확인하세요.
        <br />
        필요 없는 항목은 빼고, 꼭 필요한 것만 더할 수 있어요.
      </Box>

      <Spacing gap={24} />
      <BaseStack>
        {DIFF_ITEMS.map((item, i) => (
          <BaseStack
            key={item.title}
            direction="horizontal"
            spacing={16}
            alignItems="center"
            py="20px"
            borderTop={i === 0 ? "none" : `1px solid ${baseColors.line_normal}`}
          >
            <GraphicIcon name={item.icon} size={40} />
            <Box flex={1} minWidth={0}>
              <Box className="body_1_normal_sb" color={baseColors.label_normal}>
                {item.title}
              </Box>
              <Box className="label_1_r" color={baseColors.label_assistive_1}>
                {item.desc}
              </Box>
            </Box>
          </BaseStack>
        ))}
      </BaseStack>

      <Spacing gap={40} />
      <Box className="headline_2_sb" color={baseColors.label_normal} textAlign="center">
        우리 가족 장례에는 얼마가 필요할까요?
      </Box>
      <Spacing gap={4} />
      <Box className="body_2_normal_r" color={baseColors.label_assistive_1} textAlign="center">
        상황에 맞는 예상 비용부터 정확히 확인해 보세요.
      </Box>

      <Spacing gap={16} />
      <BaseStack spacing={8}>
        <BaseButton type="primary" size="large" onClick={onGoForm}>
          <Box className="body_1_normal_m">내 상황에 맞는 예상 비용 확인하기</Box>
        </BaseButton>
        <Box
          as="button"
          width="100%"
          p="12px 24px"
          borderRadius="6px"
          bg={baseColors.fill_normal}
          textAlign="center"
          cursor="pointer"
          onClick={onRequest}
        >
          <Box className="body_1_normal_m" color={baseColors.label_alternative_1}>
            장례 전체 예상 비용 알아보기
          </Box>
          <Box className="caption_1_r" color={baseColors.label_assistive_1}>
            장례식장, 상조, 화장장 등 전체 비용 확인
          </Box>
        </Box>
      </BaseStack>
    </LandingSection>
  );
}
